import { DatePickerProps } from "@amzn/awsui-components-react";

export const datePickerI18nStrings: DatePickerProps.I18nStrings = {
    currentMonthAriaLabel: "Current month",
    nextMonthAriaLabel: "Next month",
    nextYearAriaLabel: "Next year",
    previousMonthAriaLabel: "Previous month",
    previousYearAriaLabel: "Previous year",
    todayAriaLabel: "Today",
};